import axios from 'axios';

// Use environment variable with fallback to window.location.origin
const BACKEND_URL = (typeof process !== 'undefined' && process.env?.REACT_APP_BACKEND_URL) || window.location.origin;
const API_BASE = `${BACKEND_URL}/api`;

if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
  console.log('🔧 API Configuration:', {
    BACKEND_URL,
    API_BASE,
    env: process.env?.REACT_APP_BACKEND_URL,
    source: process.env?.REACT_APP_BACKEND_URL ? 'env variable' : 'window.location.origin'
  });
}

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // Log response errors (development only) — never log request bodies (PII)
    if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
      console.error('Axios response error:', {
        status: error.response?.status,
        url: error.config?.url,
        message: error.message
      });
    }

    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_data');
      window.location.href = '/login';
    }
    // Return structured error object for proper error handling in useApi hook.
    // FastAPI 422s put an array of objects in `detail` — flatten to a string so
    // components can safely render it (e.g. in toasts) without crashing React.
    const data = error.response?.data;
    if (data && Array.isArray(data.detail)) {
      data.detail = data.detail
        .map((d) => (typeof d === 'string' ? d : d?.msg || 'Invalid input'))
        .join('; ');
    } else if (data && data.detail && typeof data.detail !== 'string') {
      data.detail = JSON.stringify(data.detail);
    }
    return Promise.reject(data || { detail: error.message || 'Network error occurred' });
  }
);


export default api;
